/*global $:false*/

import runtimeloader from '@cob/ui-genesis/helpers/cob.runtimeloader.js';
import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

var CustomResource = function(core, localExports) {
    var _$mainContainer,
        _customResourceP,
        _name, _url,
        _globalVarStorage;

   const enrichedUtils = {...utils, ...runtimeloader(core)};

    var _exportGlobalVars = function(){
        window.cob = window.cob || {};

        // save the existing references
        _globalVarStorage = {};
        _globalVarStorage.app = window.cob.app;
        _globalVarStorage.ui = window.cob.ui;
        _globalVarStorage.utils = window.cob.utils;

        window.cob.app = core;
        window.cob.ui = ui;
        window.cob.utils = enrichedUtils;
        if (localExports) Object.assign(window.cob, localExports);
    }

    var _unexportGlobalVars = function(){
        // reset the previous references
        if (_globalVarStorage){
            window.cob.app = _globalVarStorage.app;
            window.cob.ui = _globalVarStorage.ui;
            window.cob.utils = _globalVarStorage.utils;

            _globalVarStorage = undefined;
        }

        if (localExports) Object.keys(localExports).forEach((key) => delete window.cob[key])
    }

    return{
        init: function(name, url) {
            _exportGlobalVars();
            _$mainContainer = $("<section id=\"" + url +
               "\" data-name=\"" + name +
               "\" class=\"custom-resource cob-app\"></section>");

            _customResourceP = new ResourcePresenter(core, _$mainContainer);
            _customResourceP.showContent(url);

            _$mainContainer.appendTo('body');
            _name = name;
            _url = url;
        },
        getDescription: function(){
            return _name;
        },
        acceptsRoute: function(paths){
           return paths.length === 2 && paths[1] === _url;
        },
        pause: function(){
            _unexportGlobalVars();
            _$mainContainer.trigger("pause");
            _$mainContainer.detach();
        },
        resume: function(paths){
            _exportGlobalVars();
            _$mainContainer.appendTo('body');
            _$mainContainer.trigger("resume", [paths]);
        },
        destroy: function(){
            _unexportGlobalVars();
            _$mainContainer.trigger("destroy");
            _$mainContainer.remove();
        }
    };
};

var ResourcePresenter = function(core, container) {

    var _loadingKey = core.getLoadingKey();

    const loadScript = function(script, callback, idx){
        const newScript = document.createElement("script");
        Array.from(script.attributes)
            .forEach( (attr) => newScript.setAttribute(attr.name, attr.value) );

        if(script.innerHTML.length > 0) newScript.appendChild(document.createTextNode(
            'try {' +
            script.innerHTML +
            '}catch(e){' +
            '   if(typeof Sentry !== "undefined") Sentry.addBreadcrumb({' +
                    'category: "script",' +
                    'level: "error",' +
                    'message: \'An error occurred evaluating the inline script number ' + idx + '\'' +
                '});' +
            '   e.stack = e.stack + \'\\nEvaluating the inline script number ' + idx + '\';' +
            '   window.console.error("error on inline script ' + idx + '", ' +
            JSON.stringify(script.innerHTML.substr(1,500)) + ', "(should have a subsequent error with details)");' +
            '   throw e;' +
            '}'
        ));

        newScript.onreadystatechange = callback;
        newScript.onload = callback;

        script.parentNode.replaceChild(newScript, script);

        // if there's no src, it's an inline script and onload never happens
        if(script.src === '') setTimeout(() => callback(), 0);

        // if the parent node is not a current part of the document, the onload never happens
        if(!newScript.parentNode.isConnected) setTimeout(() => callback(), 0);
    }

    const fakeSyncScriptLoading = function(scripts, callback, idx){
        if (scripts.length === 0){
            callback();
        } else {
            loadScript(scripts.shift(), () => fakeSyncScriptLoading(scripts, callback, idx+1), idx)
        }
    }

    const setInnerHtml = function (responseText, contentUrl) {
        // try to detect self-closing divs, that aren't valid and will not work correctly
        if ((/<div[^>]*\/>/).test(responseText)) {
            /* eslint-disable-next-line  */
            if(typeof Sentry !== 'undefined') Sentry.captureMessage("Found self-closing div at " + contentUrl);
        }

        const elm = container[0];
        elm.innerHTML = responseText;
        setTimeout(() => {
            fakeSyncScriptLoading(Array.from(elm.querySelectorAll("script")), () => {
                core.hideLoading(_loadingKey, "loading custom resource " + contentUrl);
            }, 1);
        }, 0);
    };

    return {
        showContent: function(contentUrl) {
            let finalContentUrl = contentUrl;
            core.showLoading(_loadingKey, "loading custom resource " + contentUrl);
            const isDirectoryDashboard = !contentUrl.endsWith('.html');
            if(isDirectoryDashboard){
               finalContentUrl = contentUrl + '/dist/dashboard.html';
            }

            $.ajax({
                'url': "localresource/" + finalContentUrl,
                'dataType': 'html',
                success: function(responseText) {
                    setInnerHtml(responseText, finalContentUrl);
                },
                error: function(req) {
                    if(req.status == 404 && isDirectoryDashboard) {
                        finalContentUrl = contentUrl + '/dashboard.html';
                        $.ajax({
                            'url': "localresource/" + finalContentUrl,
                            'dataType': "html",
                            success: function(responseText) {
                                setInnerHtml(responseText, finalContentUrl);
                                /* eslint-disable-next-line  */
                                if(typeof Sentry !== 'undefined') Sentry.captureMessage("Found DEPRECATED dashboard at ["
                                    + finalContentUrl + "] dashboard.html file should be in 'dist' directory");
                            },
                            error: function() {
                                setInnerHtml("Invalid URL", finalContentUrl);
                            }
                        })
                    } else {
                        setInnerHtml("Invalid URL", finalContentUrl);
                    }
                }
            })
        }
    };
};

export default CustomResource;
